import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Account } from "@/components/account";
import { AppShell } from "@/components/app-shell";
import { isUnauthenticated } from "@/lib/api-error";
import { sessionQuery } from "@/lib/session";

/**
 * Every admin page: a signed-in employee, in the shell. Without a session the browser goes to
 * `/login`, which comes back here afterwards. Child routes read the employee from the context
 * (`Route.useRouteContext()`); when the session ends later, the 401 that follows does the same
 * (`main.tsx`).
 */
export const Route = createFileRoute("/_admin")({
	beforeLoad: async ({ context, location }) => {
		try {
			const session = await context.queryClient.ensureQueryData(sessionQuery());
			return { session };
		} catch (error) {
			if (isUnauthenticated(error)) throw redirect({ to: "/login", search: { redirect: location.href } });
			throw error;
		}
	},
	component: AdminLayout,
});

function AdminLayout() {
	const { session } = Route.useRouteContext();
	return (
		<AppShell footer={<Account employee={session.employee} />}>
			<Outlet />
		</AppShell>
	);
}
